import { apiPath } from "@/api/api-path"
import axios from "axios"

export async function getAllSiteList() {
  const xApiKey = localStorage.getItem("self-check-in-x-api-key")
  return axios
    .get(apiPath.getSiteList, {
      headers: {
        "X-API-KEY": xApiKey,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function uploadVisitorImage(visitorImage) {
  const xApiKey = localStorage.getItem("self-check-in-x-api-key")
  let formData = new FormData()
  formData.append("Image", visitorImage)

  return axios
    .post(apiPath.uploadVisitorImage, formData, {
      headers: {
        "X-API-KEY": xApiKey,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function getAvailableCheckInList(visitorInfo) {
  const xApiKey = localStorage.getItem("self-check-in-x-api-key")
  return axios
    .post(apiPath.getAvailableCheckInList, visitorInfo, {
      headers: {
        "X-API-KEY": xApiKey,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function visitorCheckIn(visitorInfo) {
  const xApiKey = localStorage.getItem("self-check-in-x-api-key")
  return axios
    .post(apiPath.visitorCheckIn, visitorInfo, {
      headers: {
        "X-API-KEY": xApiKey,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}
